// import history from "./history";
import {getItem,setItem,clearAll,removeItem} from "./Storage.js";

const axios = require("axios").default;

axios.interceptors.request.use(
    function(config){
        config.timeout = 3600000 //1 jam
        if (config.data instanceof FormData) {
            config.headers["Content-Type"] = "multipart/form-data";
          }else if(config.data instanceof URLSearchParams){
            config.headers["Content-Type"] = "application/x-www-form-urlencoded";
          }
           else {
            config.headers["Content-Type"] = "application/json";
        }
        if (getItem("access_token")) {
          config.headers.Authorization = "Bearer " + getItem("access_token");
        }

        return config;
    },
    function(error) {
        return Promise.reject(error);
    }
);

axios.interceptors.response.use(
  function(response){
    return response;
  },
  function(error){
    const originalRequest = error.config;
    var code = error.response ? error.response.status : 500;
    if (code === 401 && getItem("refresh_token")) {
      var data = new URLSearchParams();
      var user = JSON.parse(getItem("user_info"));

      data.append("client_id", 'ro.client');
      data.append("client_secret", process.env.REACT_APP_SECRET);
      data.append("grant_type", "refresh_token");
      data.append("refresh_token", getItem("refresh_token"));
      if (getItem("GR") === "Vendor") {
        data.append("session_token", localStorage.getItem("session_token_"));
      } else {
        data.append("session_token", localStorage.getItem("session_token__"));
      }
      data.append("username", user.email);
      //console.log(data);
      return axios
        .post(process.env.REACT_APP_URL_AUTH + "connect/token", data)
        .then(res => {
          setItem("user_info", JSON.stringify(res.data));
          setItem("access_token", res.data.access_token);
          setItem("refresh_token", res.data.refresh_token);
          localStorage.setItem("session_token_", res.data.session_token);
          return axios(originalRequest);
        })
        .catch((err) => {
          console.log(err);
          removeItem("access_token")
          removeItem("refresh_token")
          // var gr = getItem("GR").toLocaleLowerCase();

          // logInfo("Redirect Login", {
          //   code: 401,
          //   type: "refresh_token",
          //   role: gr,
          //   request: originalRequest,
          // });
          setTimeout(() => {
            clearAll();
            return (window.location.href ="/auth/vdr/login");
          }, 2000);
        });
    }
    if (code === 401 && !getItem("access_token")) {
      // var gr = getItem("GR").toLocaleLowerCase();

      // logInfo("Redirect Login", {
      //   code: 401,
      //   type: "no_token",
      //   role: gr,
      //   request: originalRequest,
      // });
      setTimeout(() => {
        clearAll();
        return (window.location.href ="/auth/vdr/login");
      }, 2000);
    }
    // if (code !== 401) {
    //   if (!error.response) {
    //     var d = originalRequest.data;
    //     var pe = null;
    //     try {
    //       pe = d.get("prevent_error");
    //     } catch (error) {}
    //     alertData.setOpen(true);
    //     var e = error.toString();
    //     var messages = e.split(":")[1];
    //     if (!pe) {
    //       if (messages.indexOf("Network Error") > -1) {
    //         if (getItem("TEST_ATTEMPT") === "true") {
    //           alertData.setReconnecting(true);
    //         }
    //         alertData.setMessage(i18next.t("error.network.disconnected"));
    //       } else {
    //         alertData.setMessage(
    //           i18next.t("error.exception.title") +
    //             ", " +
    //             i18next.t("error.exception.description")
    //         );
    //       }
    //     }
    //   }
    // }


    if(error.request.responseType === 'blob'){
      return new Promise((resolve, reject) => {
        let reader = new FileReader();
        reader.onload = () => {
          let a = reader.result;
            error.response.data = a;
            let customError = {
              code: error.response ? error.response.status : 500,
              message: error.response ? error.response.statusText : "Internal Error",
              data: error.response ? error.response.data : {}
            };

            // if (customError.code === 401) {
            //   history.replace("/error/401");
            // } else if (customError.code === 403) {
            //   history.replace("/error/403");
            // } else if (customError.code === 404) {
            //   history.replace("/error/404");
            // } else if (customError.code === 500) {
            //   history.replace("/error/500");
            // }
            
            resolve(Promise.reject(customError));
        };

        reader.onerror = () => {
            reject(error);
        };

        reader.readAsText(error.response.data);
      })
    }

    let customError = {
      code: error.response ? error.response.status : 500,
      message: error.response ? error.response.statusText : "Internal Error",
      data: error.response ? error.response.data : {}
    };

    // if (customError.code === 401) {
    //   history.replace("/error/401");
    // } else if (customError.code === 403) {
    //   history.replace("/error/403");
    // } else if (customError.code === 404) {
    //   history.replace("/error/404");
    // } else if (customError.code === 500) {
    //   history.replace("/error/500");
    // }

    return Promise.reject(customError);
  }
);

const decode = obj => {
    try {
      return new URLSearchParams(obj).toString();
    } catch (error) {
      return false;
    }
};

export const unwrapItems = data => {
  if (Array.isArray(data)) {
    return data;
  }
  if (data && Array.isArray(data.items)) {
    return data.items;
  }
  if (data && Array.isArray(data.Items)) {
    return data.Items;
  }
  return [];
};

export const unwrapPagination = data => {
  if (!data || Array.isArray(data)) {
    return {
      page: 1,
      pageSize: Array.isArray(data) ? data.length : 0,
      totalCount: Array.isArray(data) ? data.length : 0,
    };
  }

  return {
    page: data.page || data.Page || 1,
    pageSize: data.pageSize || data.PageSize || unwrapItems(data).length,
    totalCount: data.totalCount || data.TotalCount || unwrapItems(data).length,
  };
};

export const withPaginationQuery = (query = "", page = 1, pageSize = 100) => {
  let nextQuery = query || "";
  const hasPage = /[?&]page=/i.test(nextQuery);
  const hasPageSize = /[?&]pageSize=/i.test(nextQuery);
  const params = [];

  if (!hasPage) {
    params.push(`page=${page}`);
  }
  if (!hasPageSize) {
    params.push(`pageSize=${pageSize}`);
  }
  if (params.length === 0) {
    return nextQuery;
  }
  if (nextQuery === "" || nextQuery === "?") {
    return `?${params.join("&")}`;
  }

  const separator = nextQuery.includes("?")
    ? (nextQuery.endsWith("?") || nextQuery.endsWith("&") ? "" : "&")
    : "?";
  return `${nextQuery}${separator}${params.join("&")}`;
};

const appendQuery = (uri, query) => {
  if (!query) {
    return uri;
  }

  if (typeof query === "string") {
    const normalizedQuery = query.startsWith("?") ? query.substring(1) : query;
    if (!normalizedQuery) {
      return uri;
    }
    const separator = uri.includes("?")
      ? (uri.endsWith("?") || uri.endsWith("&") ? "" : "&")
      : "?";
    return `${uri}${separator}${normalizedQuery}`;
  }

  const encodedQuery = decode(query);
  if (!encodedQuery) {
    return uri;
  }
  const separator = uri.includes("?")
    ? (uri.endsWith("?") || uri.endsWith("&") ? "" : "&")
    : "?";
  return `${uri}${separator}${encodedQuery}`;
};

const withPageOnUri = (uri, page, pageSize) => {
  const queryIndex = uri.indexOf("?");
  if (queryIndex < 0) {
    return uri + withPaginationQuery("", page, pageSize);
  }

  const baseUri = uri.substring(0, queryIndex);
  const params = new URLSearchParams(uri.substring(queryIndex + 1));
  params.set("page", page);
  params.set("pageSize", pageSize);
  return `${baseUri}?${params.toString()}`;
};

export async function RequestGet(uri, query, config) {
    if (query) {
      query = "?" + decode(query);
    }
    var url =
      uri.indexOf("https://") === 0 || uri.indexOf("http://") === 0
        ? uri
        : process.env.REACT_APP_URL_API + uri;
    return await axios.get(url + (query || ""), config);
}

export async function RequestGetAllPages(uri, query, pageSize = 100, config) {
  const baseUri = appendQuery(uri, query);
  const firstResponse = await RequestGet(withPageOnUri(baseUri, 1, pageSize), null, config);
  const firstItems = unwrapItems(firstResponse.data);

  if (Array.isArray(firstResponse.data)) {
    return { ...firstResponse, data: firstItems, pagination: unwrapPagination(firstResponse.data) };
  }

  const firstPagination = unwrapPagination(firstResponse.data);
  const effectivePageSize = firstPagination.pageSize || pageSize;
  const totalCount = firstPagination.totalCount || firstItems.length;
  const totalPages = effectivePageSize > 0 ? Math.ceil(totalCount / effectivePageSize) : 1;

  if (totalPages <= 1) {
    return {
      ...firstResponse,
      data: firstItems,
      pagination: {
        ...firstPagination,
        page: 1,
        pageSize: effectivePageSize,
        totalCount,
      },
    };
  }

  const allItems = [...firstItems];
  for (let nextPage = 2; nextPage <= totalPages; nextPage += 1) {
    const response = await RequestGet(withPageOnUri(baseUri, nextPage, effectivePageSize), null, config);
    const pageItems = unwrapItems(response.data);
    allItems.push(...pageItems);
    if (pageItems.length === 0) {
      break;
    }
  }

  return {
    ...firstResponse,
    data: allItems,
    pagination: {
      ...firstPagination,
      page: 1,
      pageSize: effectivePageSize,
      totalCount,
    },
  };
}

export async function RequestPost(uri, data, config) {
  var url =
    uri.indexOf("https://") === 0 || uri.indexOf("http://") === 0
      ? uri
      : process.env.REACT_APP_URL_API + uri;
  return await axios.post(url, data, config);
}

export async function RequestPostAuth(uri, data, config) {
  var url =
    uri.indexOf("https://") === 0 || uri.indexOf("http://") === 0
      ? uri
      : process.env.REACT_APP_URL_AUTH + uri;
  return await axios.post(url, data, config);
}

export async function RequestPut(uri, data) {
  var url =
    uri.indexOf("https://") === 0 || uri.indexOf("http://") === 0
      ? uri
      : process.env.REACT_APP_URL_API + uri;
  return await axios.put(url, data);
}

export async function RequestDelete(uri){
  var url =
    uri.indexOf("https://") === 0 || uri.indexOf("http://") === 0
      ? uri
      : process.env.REACT_APP_URL_API + uri;
  return await axios.delete(url);
}
